// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","container":"Ga7335a G3185e3 Ga7380c Gedde38 G90bbe6 Gcf189c"};